export default class ScormEvent {
    constructor(type) {
        this.type = type;
    }
}

ScormEvent.START_SESSION = "ScormEvent.START_SESSION";
ScormEvent.END_SESSION = "ScormEvent.END_SESSION";